import "./style.scss";
import { Global } from "./common/global";
import { Server } from "./common/callServer";

window.addEventListener("load", () => {
  Global.serverObj = new Server();
  Global.serverObj.send(
    Global.URL_CREATE,
    setUID.bind(this),
    null,
    {
      device: Global.isMobile ? "mobile" : "web",
      fresh: true,
      saveType: "create",
      source: Global.source,
    },
    "POST",
    null,
    false
  );

  // console.log("LOAD");

  window.mobileCheck = function () {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  Global.isMobile = window.mobileCheck();
  // console.log(Global.isMobile, " check");

  Global.sound = document.querySelector("#BG_Music");

  /* document.querySelector("body").addEventListener("click", () => {
    if (Global.oncePlayed) {
      Global.sound.play();
      document.querySelector(".soundImg").src =
        "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Sound_01.png";
      Global.playingMusic = true;
      Global.oncePlayed = false;
    }
  }); */

  setTimeout(() => {
    // document.querySelector(".spinner").style.display = "none";
    // document.querySelector(".mainContainer").style.display = "flex";
    setTimeout(() => {
      Initiate();

      setTimeout(() => {
        document.querySelector(".instructionDiv").style.opacity = "1";
        setTimeout(() => {
          showInstruction();
        }, 2000);

        const gridItems = document.querySelectorAll(".grid-item");

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("visible");
                observer.unobserve(entry.target); // Stop observing once it's visible
              }
            });
          },
          {
            threshold: 0.1, // Trigger when 10% of the item is visible
          }
        );

        gridItems.forEach((item) => {
          observer.observe(item);
        });
      }, 1500);
    }, 1000);
  }, 1000);

  document.getElementById("myDIV").addEventListener("scroll", function () {
    var diff = difference(
      this.scrollTop + this.clientHeight,
      this.scrollHeight
    );
    // console.log(diff, " diff");

    if (diff < 150) {
      // alert("Scroll Ends Here");
      document.querySelector(".BottomDiv").style.visibility = "visible";
      setTimeout(() => {
        document.querySelector(".BottomDiv").style.opacity = "1";
      }, 100);
      return;
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const progressLeft = document.querySelector(".progress-left");
  const progressRight = document.querySelector(".progress-right");
  const progressPercentage = document.querySelector(".progress-percentage");

  let progress = 0;

  function updateProgress() {
    progress += 1;
    if (progress > 100) progress = 100;

    if (progress <= 50) {
      progressRight.style.transform = `rotate(${progress * 3.6}deg)`;
      progressLeft.style.transform = "rotate(0deg)";
      document.querySelector(".loader-image").style.transform =
        "translateY(0%)";
    } else {
      progressRight.style.transform = "rotate(180deg)";
      progressLeft.style.transform = `rotate(${(progress - 50) * 3.6}deg)`;
    }

    progressPercentage.textContent = `${progress}%`;

    if (progress < 100) {
      requestAnimationFrame(updateProgress);
    } else {
      document.querySelector(".loader-container").style.display = "none";
      document.querySelector(".mainContainer").style.display = "flex";
    }
  }

  // Start updating the progress
  requestAnimationFrame(updateProgress);
});

function difference(first, sec) {
  return Math.abs(first - sec);
}

var instCounter = 1;
function showInstruction() {
  instCounter++;

  // document.querySelector(".sprite").classList.add(`Swipe-Up_${instCounter}`);
  document.getElementById(
    "instImg"
  ).src = `https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Instruction/Swipe_Up_${instCounter}.png`;

  let aa = setTimeout(() => {
    showInstruction();
  }, 50);

  if (instCounter === 45) {
    clearTimeout(aa);
    document.querySelector(".instructionDiv").style.display = "none";
    document.querySelector(".mainContainer").style.overflowY = "scroll";
  }
}

function setUID(data) {
  // console.log(data, "gaggh");
  let v = JSON.parse(data);
  // console.log(v, "gaggh");
  Global.U_ID = v.uid;
  Global.gameKey = v.game_key;

  // console.log(Global.U_ID, " gaggh ", Global.gameKey);
}

function Initiate() {
  // document.querySelector(".soundBtn").style.opacity = "1";
  document.querySelector(".logo").style.opacity = "1";
  document.querySelector(".great").style.transform = "translateX(0%)";
  document.querySelector(".special").style.transform = "translateX(0%)";

  let allOptions = document.querySelectorAll(".options");
  for (let i = 0; i < allOptions.length; i++) {
    allOptions[i].addEventListener("click", () => {
      checkAnswer(allOptions[i]);
    });
  }

  document.querySelector(".copyImg").addEventListener("click", () => {
    CopyToClipboard();
  });

  document.querySelector(".shopBtn").addEventListener("click", () => {
    openShoppe();
  });

  document.getElementById("tryAgainBtn").addEventListener("click", () => {
    tryAgain();
  });

  createProductTiles();

  /*  document.querySelector(".soundBtn").addEventListener("click", () => {
    toggleSound();
  }); */
}

function toggleSound() {
  // console.log(Global.playingMusic, "Global.playingMusic");
  if (Global.playingMusic === true) {
    Global.sound.pause();
    Global.playingMusic = false;
    // console.log(Global.playingMusic, "1111");
    document.querySelector(".soundImg").src =
      "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Sound_02.png";
  } else {
    // console.log(Global.playingMusic, "2222");
    Global.sound.play();
    Global.playingMusic = true;
    document.querySelector(".soundImg").src =
      "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Sound_01.png";
  }
}

function createProductTiles() {
  // console.log("jKKJKJJ");

  const grid = document.getElementById("productContainer");
  Global.imageUrls = [
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_01.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_02.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_03.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_04.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_05.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_06.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_07.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_08.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_09.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_10.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_11.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_12.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_13.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_14.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_15.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_16.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_17.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_18.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_19.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_20.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_21.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_22.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_23.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_24.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_25.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_26.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_27.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_28.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_29.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_31.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_32.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_33.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_34.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_35.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_36.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_37.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_38.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_39.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_40.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_41.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_42.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_43.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_44.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_45.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_46.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_47.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_48.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_49.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_50.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_51.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_52.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_53.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_54.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_55.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_56.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_57.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_58.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_59.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_60.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_61.png",
    "https://newsfeedsmartapp.com/GreatSamsungScroll/assets/Products/Products_62.png",
  ];

  for (let i = 0; i < 62; i++) {
    const item = document.createElement("div");
    item.className = "grid-item";
    const img = document.createElement("img");
    img.src = Global.imageUrls[i % Global.imageUrls.length];
    item.appendChild(img);
    item.style.animationDelay = `${i * 0.1}s`;
    grid.appendChild(item);
  }
  // });
}

function tryAgain() {
  Global.gameTry += 1;

  Global.serverObj.send(
    Global.VALUE_UPDATER,
    null,
    null,
    {
      saveType: "tryagain",
      uniqID: Global.U_ID,
      encryptkey: Global.gameKey,
    },
    "POST",
    null,
    false
  );

  let gridItems = document.querySelectorAll(".grid-item");
  for (let i = 0; i < gridItems.length; i++) {
    if (i > 5) {
      gridItems[i].classList.remove("visible");
    }
  }

  const imageSources = Array.from(gridItems).map(
    (item) => item.querySelector("img").src
  );

  // Shuffle the imageSources array using Fisher-Yates shuffle algorithm
  for (let i = imageSources.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [imageSources[i], imageSources[j]] = [imageSources[j], imageSources[i]];
  }

  // Apply the shuffled sources back to the grid items
  gridItems.forEach((item, index) => {
    item.querySelector("img").src = imageSources[index];
  });

  setTimeout(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target); // Stop observing once it's visible
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the item is visible
      }
    );

    gridItems.forEach((item) => {
      observer.observe(item);
    });
  }, 2000);

  let section = document.querySelector(".logo");
  if (section) {
    section.scrollIntoView({
      behavior: "smooth",
    });
  }

  setTimeout(() => {
    document.querySelector(".BottomDivQuest").style.display = "flex";
    document.querySelector(".WrongDiv").style.display = "none";
  }, 1000);
}

function checkAnswer(elem) {
  // console.log(elem, " aaadk");
  let answerData = elem.dataset.answer;
  let answerVal = elem.dataset.answerval;

  // console.log(answerVal, " answerVal");
  Global.serverObj.send(
    Global.WEBSERVICE,
    {},
    null,
    {
      saveType: "saveAnswer",
      uniqID: Global.U_ID,
      answer: answerVal,
      gametry: Global.gameTry,
    },
    "POST",
    null,
    false
  );

  // // console.log(answerData, " answer");
  if (answerData === "correct") {
    showCoupon();
  } else {
    showOops();
  }
}
function showCoupon() {
  document.querySelector(".BottomDivQuest").style.display = "none";
  document.querySelector(".CorrectDiv").style.display = "flex";

  setTimeout(() => {
    document.querySelector(".CorrectDiv").style.opacity = "1";
  }, 10);
}

function CopyToClipboard() {
  // console.log("COPYY");

  var tooltip = document.getElementById("tooltip");
  // tooltip.classList.add("show");
  tooltip.style.opacity = "1";

  var copyText = document.querySelector(".CorrectHeadCoupon");
  var textToCopy = copyText.textContent;

  // Copy the text inside the text field
  // navigator.clipboard.writeText(copyText.textContent);

  if (navigator.clipboard && window.isSecureContext) {
    // Use the Clipboard API
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        // alert("Text copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  } else {
    // Fallback for browsers that do not support Clipboard API
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      const msg = successful ? "successful" : "unsuccessful";
      // alert("Fallback: Copying text command was " + msg);
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  }

  setTimeout(() => {
    tooltip.style.opacity = "0";
    // tooltip.style.display = "none";
  }, 2000);
}

function showOops() {
  document.querySelector(".BottomDivQuest").style.display = "none";
  document.querySelector(".WrongDiv").style.display = "flex";

  setTimeout(() => {
    document.querySelector(".WrongDiv").style.opacity = "1";
  }, 10);
}

function openShoppe() {
  Global.serverObj.send(
    Global.VALUE_UPDATER,
    null,
    null,
    {
      saveType: "shopNow",
      uniqID: Global.U_ID,
      encryptkey: Global.gameKey,
    },
    "POST",
    null,
    false
  );
  // // console.log("Shoppee");

  window.open("https://shopee.sg/m/samsung-sbd", "_blank");
}
